import { Button, Icon, IconStatus, Text, HStack, VStack } from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';
import { Box, Pressable } from 'native-base';
import React from 'react';

interface HeaderSectionProps {
  sendId?: string;
  status?: string;
  lastUpdate?: string;
  onCloseDetails: () => void;
  onDownloadFile: () => void;
  canDownloadFile?: boolean;
  loading?: boolean;
  iconName?: IconographyTypes.Option;
  iconColor?: ColorTypes.Option;
  iconSize?: Utils.IconTypes.SizeTokens;
  iconBackgroundColor?: ColorTypes.Option;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  lastUpdate,
  onCloseDetails,
  onDownloadFile,
  canDownloadFile,
  sendId,
  status,
  loading,
  iconName,
  iconColor,
  iconSize,
  iconBackgroundColor,
}) => {
  const handleDownloadFile = () => {
    if (canDownloadFile) {
      onDownloadFile();
    }
  };

  const getStatusIcon = () => {
    if (loading) {
      return null;
    }

    if (iconName && iconColor && iconSize && iconBackgroundColor) {
      return (
        <IconStatus
          icon={iconName}
          color={iconColor}
          testId="header-section-status-icon"
          size={iconSize}
          bgColor={iconBackgroundColor}
        />
      );
    }
  };

  const currentStatus = getStatusIcon();

  return (
    <VStack>
      <HStack alignItems="center" space={Spacing['stack.md']}>
        <VStack flex={1}>
          <HStack alignItems="center">
            <Pressable onPress={onCloseDetails}>
              <Icon
                name="ArrowLeft"
                color={Color['neutral.black']}
                size="xs"
                testId="arrow-left-button"
              />
            </Pressable>
            <Text
              isLoading={loading}
              pl={Spacing['inset.quarck']}
              fontSize={Typography['fontsize.lg']}
              fontWeight={Typography['fontweight.semibold']}>
              Detalhes da solicitação {sendId}
            </Text>
            <HStack
              flex={1}
              pl={Spacing['inset.xs']}
              space={Spacing['stack.quarck']}
              alignItems="center">
              {currentStatus}
              <Text
                isLoading={loading}
                pl={Spacing['inset.quarck']}
                fontSize={Typography['fontsize.xs']}>
                {status}
              </Text>
            </HStack>
          </HStack>
          <HStack pt={Spacing['inset.nano']} space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.xs']}
              fontWeight={Typography['fontweight.semibold']}
              color="neutral.medium">
              Ultima atualização:
            </Text>
            <Text
              isLoading={loading}
              flex={1}
              pl={Spacing['inset.xs']}
              fontSize={Typography['fontsize.xs']}>
              {lastUpdate}
            </Text>
          </HStack>
        </VStack>

        <HStack height="100%">
          <VStack
            flex={1}
            alignItems="flex-start"
            justifyItems="flex-start"
            justifyContent="flex-start">
            <HStack space={Spacing['stack.nano']}>
              <Button
                disabled={!canDownloadFile}
                onPress={handleDownloadFile}
                variant="secondary"
                paddingX={Spacing['inset.xs']}
                paddingY={Spacing['inset.quarck']}
                _text={{
                  fontWeight: Typography['fontweight.semibold'],
                  color: canDownloadFile ? Color['neutral.black'] : Color['neutral.medium'],
                }}
                rightIcon={
                  <Icon
                    name="Pdf"
                    testId="pdf-icon"
                    color={canDownloadFile ? Color['neutral.black'] : Color['neutral.medium']}
                    size="xxs"
                  />
                }>
                EXPORTAR
              </Button>

              <VStack alignItems="center" justifyContent="center">
                <Pressable
                  onPress={onCloseDetails}
                  padding={1}
                  borderWidth={0.5}
                  borderColor={Color['brand.primary.principal']}
                  borderRadius="full">
                  <Icon
                    name="Close"
                    color={Color['brand.primary.principal']}
                    size="xxxxxs"
                    testId="status-icon"
                  />
                </Pressable>
              </VStack>
            </HStack>
          </VStack>
        </HStack>
      </HStack>
      <Box
        mt={Spacing['stack.xxxs']}
        mb={Spacing['stack.xxs']}
        borderTopWidth={0.5}
        borderTopColor={Color['neutral.light']}
      />
    </VStack>
  );
};
